module.exports = __webpack_public_path__ + "static/foundstages-36f94ca357329828d29a083e906214db.jpg";